<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoEditar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoEditar">
			<form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="flex justify-content-center" *ngIf="exibirSpinner">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div class="p-fluid p-formgrid grid">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
					</div>
				</div>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid pt-3" *ngIf="contrato && !exibirSpinner">
						<div class="field col-12 md:col-4">
							<label htmlFor="razaoSocial">Razão Social</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite a descrição do Fabricante" name="razaoSocial" ngModel
								[(ngModel)]="contrato.razaoSocial" #razaoSocial="ngModel" required />
							<div *ngIf="razaoSocial.hasError('required') && razaoSocial.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cnpj">CNPJ</label>
							<p-inputMask mask="99.999.999/9999-99" [unmask]="true" type="text" name="cnpj"
								[(ngModel)]="contrato.cnpj" ngModel #cnpj="ngModel"> </p-inputMask>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cpfTitular">CPF do Titular</label>
							<p-inputMask mask="999.999.999-99" [unmask]="true" type="text" placeholder="000.000.000-00"
								name="cpfTitular" ngModel #cpfTitular="ngModel" [(ngModel)]="contrato.cpfTitular">
							</p-inputMask>
						</div>
						<div class="field col-12 md:col-1">
							<label for="ativo">Ativo</label>
							<br />
							<p-inputSwitch name="ativo" [(ngModel)]="contrato.ativoContratante"></p-inputSwitch>
						</div>

					</div>
					<div class="card col-12" *ngIf="contrato && !exibirSpinner">
						<div class=" components p-fluid p-formgrid grid">
							<div class="field col-12 md:col-3">
								<label htmlFor="grupo">Grupo</label>
								<p-dropdown [options]="listaGrupos" optionLabel="descricao" [filter]="true"
									emptyFilterMessage="Nenhum registro" placeholder="Selecione" name="grupo" ngModel
									#uf="ngModel" [(ngModel)]="grupoSelecionado">
								</p-dropdown>
							</div>

							<div class="field col-12 md:col-2">
								<button pButton pRipple pTooltip="Adicionar" class="p-button-success mt-5"
									icon="pi pi-check" style="box-shadow: none;" type="button"
									(click)="adicionarRateio()" [disabled]="!modoEdicao || !grupoSelecionado">
								</button>
							</div>

						</div>
						<p-table #dt1 [value]="listaRateios" dataKey="id" [rows]="10" [rowHover]="true"
							styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
							styleClass=" p-datatable-sm">
							<ng-template pTemplate="header">
								<tr>
									<th>
										<div>
											Subgrupo
										</div>
									</th>
									<th>
										<div>
											Percentual <i class="pi pi-question-circle"
												pTooltip="Este percentual será utilizado na dedução tributária da NFS-e."></i>
										</div>
									</th>

									<th>
										<div>
											Excluir
										</div>
									</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-rateio let-i="rowIndex">
								<tr>
									<td>
										<label>{{ rateio.subgrupo.descricao }}</label>
									</td>
									<td>
										<p-inputNumber suffix="%" name="percentual{{i}}" [max]="100"
											[minFractionDigits]="1" [maxFractionDigits]="2"
											[(ngModel)]="rateio.percentualRateio">
										</p-inputNumber>
									</td>

									<td>
										<button pButton pRipple pTooltip="Excluir" type="button" icon="pi pi-trash"
											class="p-button-danger" (click)="excluirRateio(rateio)">
										</button>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="7">Nenhum registro cadastrado.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!exibirSpinner">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="button" pButton icon="pi pi-check" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem" (click)="atualizar()"
								[disabled]="!f.valid || !contrato">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem" disabled>
								</button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/contrato"></button>
						</div>
					</div>
				</div>
			</form>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>
		</div>
	</div>
</div>